import { Component, ViewChild, OnInit } from '@angular/core';
import { SuperClass } from '../../../../superclass/SuperClass';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { CookieService } from 'ngx-cookie-service';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { HttpClient } from '@angular/common/http';
import { WsService } from '../../../../services/websocket/WsService';
import { Country } from '../../vocabularies/countries/countries.model';
import { Globals } from '../../../../globals/Globals';
import { RouterConst } from '../../../../globals/RoutersConst';
import { QuillEditorComponent } from 'ngx-quill';
import { HttpService } from '../../../../services/http.service';
import { CaptivePortal } from '../cp-add-update/cp.model';
import { isNullOrUndefined, isUndefined } from 'util';
import { Locale } from '../locales/locale.model';

@Component({
  selector: 'app-terms-builder',
  templateUrl: './terms-builder.component.html',
  styleUrls: ['./terms-builder.component.css'],
})
export class TermsBuilderComponent extends SuperClass implements OnInit{
  countries = [];
  selectedCountry: Country;
  locales: any;
  languages;
  logoImage = './../../../../../assets/img/placeholders/logo_placeholder-300x167.png?id=' +
  'randomParam';
  mainImage = '?id=' + 'randomParam';
  facebookIconImage = '?id=' + 'randomParam';
  twitterIconImage = '?id=' + 'randomParam';
  nextIconImage = '?id=' + 'randomParam';
  message;
  cpList: CaptivePortal[];
  cpCodes;
  selectedRow: CaptivePortal;
  newCP: CaptivePortal;
  cpLocaleCodes;
  seleckPortalCode;
  seleckTitlePortal;
  seleckLanguage;
  sendMessage;
  currImageTag;
  @ViewChild('editor') editor: QuillEditorComponent;
  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private httpService: HttpService
  ) {
    
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );
    this.newCP = new CaptivePortal();

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Captive Portal' },
      {
        label: 'Terms Builder',
        routerLink: [{ outlets: { sub: [RouterConst.TERMS_BUILDER] } }],
      },
    ]);
  }

  ngOnInit() {
    this.http_getAllCp((data: any) => {
      this.cpList = data.payload;
      // console.log(this.cpList);
    });
  }

  selectedLangeage(a){
    this.seleckLanguage = a.value.languageCode;
    this.httpService.get(Globals.SERVER_ADDR + '/cp/tcs/get?nasid='+this.seleckPortalCode+'&lang='+this.seleckLanguage).subscribe((data: any) => {
      this.message = data.payload.text;
      this.seleckTitlePortal = data.payload.title;
    });
  }

  selectedPortalCode(a) {
    this.seleckPortalCode = a.value.nasid;
    this.httpService.get(Globals.SERVER_ADDR + '/cp/tcs/get?nasid='+this.seleckPortalCode+'&lang='+this.seleckLanguage).subscribe((data: any) => {
      this.message = data.payload.text;
      this.seleckTitlePortal = data.payload.title;
    });

    this.http_getAllLocales((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.locales = data.payload;
        // for (let i = 0; i < data.payload.length; i++) {
        //   this.locales = data.payload[i].cpLocaleCode;
        // }
        this.locales = JSON.parse(JSON.stringify(data.payload)).filter(function (i,n){
          return i.cpLocaleCode===a.value.cpLocaleCode;
      });
      }
    });
  }
  showCpLanguage() {
    if (!isUndefined(this.selectedRow)) {
      return (this.selectedRow.defaultLanguageCode = this.languages.filter(
        el => {
          return el.lang === this.selectedRow.defaultLanguageCode;
        },
      )[0]);
    }
  }

  termsBuilder() {
    this.httpService.post(Globals.SERVER_ADDR + `/cp/tcs/save?title=${this.seleckTitlePortal}&nasid=${this.seleckPortalCode}&lang=${this.seleckLanguage}`,this.message).subscribe((data: any) => {
      if(data.payload == "SUCCESS") {
        this.httpService.get(Globals.SERVER_ADDR + '/cp/tcs/get?nasid='+this.seleckPortalCode+'&lang='+this.seleckLanguage).subscribe((data: any) => {
          this.message = data.payload.text;
          this.seleckTitlePortal = data.payload.title;
        });
          this.sendMessage = true;
      }
    });
  } 

  toggleImages() {
    const clientId = this.cookiesService.get(Globals.COOKIES_CLIENT_ID);
    this.logoImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=LOGO&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.mainImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=LOGIN_IMAGE&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.facebookIconImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=CIRCLE_COLOR_FACEBOOK&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.twitterIconImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=CIRCLE_COLOR_TWITTER&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
    this.nextIconImage =
      Globals.SERVER_ADDR +
      '/cp/img/getByCpIdentifier?clientId=' +
      clientId +
      '&tag=GREY_NAV_ARROW_MD&cpIdentifier=' +
      encodeURI(this.selectedCountry.name) +
      '&id=' +
      new Date().getMilliseconds();
  }

  imageEdit(nextIconImage: string) {
    this.currImageTag = nextIconImage;
    document.getElementById('image_loader_btn').click();
  }

  onChangeImage(e) {
    this.http_uploadImage(
      this.selectedCountry.name,
      this.currImageTag,
      e,
      (data: any) => {
        this.toggleImages();
      },
    );
  }

  chooseCountry(e) {
    this.toggleImages();
  }

  getWebSocketIdentifier(): string {
    return '';
  }

  reloadData(): void {
    this.http_getImagesCountries((data: any) => {
      this.countries = data.payload;
      this.selectedCountry = this.countries[0];
      this.toggleImages();
    });
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/terms-builder/terms-builder.component.ts